import * as React from "react";
import { CustomerMergeModel } from "../../../../../../Wrap/Models/Models/Customer/CustomerMergeModel";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { doCompare, switchTypes } from "../Resource/CustomerMergeHelper";

interface ITickOrCrossProps {
    type: "customer-details" | "contact-information" | "addresses" | "regulatory" | "regulatory-checks" | "user-group";
    data: CustomerMergeModel;
}

const renderTickOrCorss = (resultArray: Array<any>, type: string) => {
    const config = [];
    if (type === "user-group") {
        resultArray.forEach((e) => {
            if (e) {
                config.push(
                    <div className="row">
                        <div className="col-12">
                            <div className="badge-match" style={{ marginBottom: "-3px", paddingLeft: "50px" }}>
                                <span className="sr-only">Lines match</span>
                                <span className="b-icon" aria-hidden="true"></span>
                            </div>
                        </div>
                    </div>
                );
            } else {
                config.push(
                    <div className="row">
                        <div className="col-12">
                            <div className="badge-nomatch" style={{ marginBottom: "-3px", paddingLeft: "50px" }}>
                                <span className="sr-only">Lines do not match</span>
                                <span className="b-icon" aria-hidden={true} />
                            </div>
                        </div>
                    </div>
                );
            }
        });
        return config;
    }
    resultArray.forEach((e) => {
        if (e) {
            config.push({
                title: (
                    <div className="badge-match" style={{ marginBottom: "-3px", paddingLeft: "50px" }}>
                        <span className="sr-only">Lines match</span>
                        <span className="b-icon" aria-hidden="true"></span>
                    </div>
                ),
                data: <div style={{ display: "none" }}>1</div>,
            });
        } else {
            config.push({
                title: (
                    <div className="badge-nomatch" style={{ marginBottom: "-3px", paddingLeft: "50px" }}>
                        <span className="sr-only">Lines do not match</span>
                        <span className="b-icon" aria-hidden={true} />
                    </div>
                ),
                data: <div style={{ display: "none" }}>1</div>,
            });
        }
    });
    return <Typography {...prepareTypography(config, 1, "common")} />;
};

export const TickOrCorss = (props: ITickOrCrossProps) => {
    const types = switchTypes(props.type);
    const customer1 = props.data.FirstCustomer;
    const customer2 = props.data.SecondCustomer;
    const resultArray = doCompare(types, customer1, customer2);

    const isAllMatch = resultArray?.findIndex((e) => e === false); // > 0 means false, -1 means true

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {isAllMatch >= 0 ? (
                        <h3 style={{ color: "red", fontSize: "14px", height: "27px" }}>Please check mismatches</h3>
                    ) : (
                        <h3 style={{ color: "green" }}>Section match</h3>
                    )}
                </div>
            </div>
            {renderTickOrCorss(resultArray, props?.type)}
        </>
    );
};
